import { LOAD_CATEGORIES, SELECT_CATEGORY, CLEAN_SELECTED_CATEGORY } from "../actions/actionTypes";

const initialState = {
    categories: [],
    selectedCategory: null
};

export const categoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_CATEGORIES:
            return {
                ...state,
                categories: action.categories
            };
        case SELECT_CATEGORY:
            return {
                ...state,
                selectedCategory: action.category
            };
        case CLEAN_SELECTED_CATEGORY:
            return {
                ...state,
                selectedCategory: null
            };
        default:
            return state;
    }
};